import React from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface Props {
  status?: string;
  onBack?: () => void;
  isSubmitting?: boolean;
  text?: string;
  centered?: boolean;
}

export const ScreenFlowFormButtons = ({
  status,
  onBack,
  isSubmitting = false,
  text = "Continue",
  centered = false,
  ...rest
}: Props): JSX.Element => {
  return (
    <Box sx={{ my: 2 }} {...rest}>
      {/*TODO: only color error if actual error, as opposed to positive status message*/}
      {status && (
        <Typography variant="body1" color="error" sx={{ mr: 1, my: 2 }}>
          {status}
        </Typography>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: onBack ? "row-reverse" : "row",
          justifyContent: "space-between",
        }}
      >
        <Button
          variant="contained"
          type="submit"
          disabled={isSubmitting}
          sx={[{ minWidth: 180 }, centered ? { margin: "0 auto" } : {}]}
        >
          {text}
        </Button>
        {onBack && (
          <IconButton
            aria-label="back"
            onClick={onBack}
            sx={{ mr: 2 }}
            className="outlined"
          >
            <ArrowBackIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};
